import React, {useState, useEffect} from 'react';
import {UPCOMING_KEY, CANCELLED_KEY, COMPLETED_KEY, FAILED_KEY} from '@ibibo/myaccount-reducer';
import megatron from 'megatron';

import * as S from './BookingCardInfoDetails.styles';
import IconSelector from '@ibibo/icon-selector';
import TripDetails from './TripDetails/TripDetails';
import TripActions from './TripActions/TripsActions';
import TripRefundDetails from './TripRefundDetails/TripRefundDetails';
import {apiConfig} from '../../../../../../../../../hotels/hotels-config';
import Modal from '../../../../../../../../hotels-dweb/src/shared/components/Modal';
import * as Styles from '../../../../../../../../hotels-dweb/src/shared/pages/ShareHotel/containers/ShareProperties.styles';
import WhatsAppLogin from '../../../../../../../../hotels-dweb/src/shared/pages/ShareHotel/containers/WhatsAppLogin';
import ShareHotelPreview from '../../../../../../../../hotels-dweb/src/shared/pages/ShareHotel/containers/ShareHotelPreview';
import {shareHotelPropertiesPOSTPDF} from '../../../../../../../../hotels-dweb/src/shared/pages/ShareHotel/redux/thunk';
import {getCookie} from './../../../../../../utils/getCookie';
const HotelDetails = ({data}) => {
  const {trip_type} = data;
  switch (trip_type.toLowerCase()) {
    case UPCOMING_KEY:
      return <TripDetails data={data} />;
    case COMPLETED_KEY:
      return <TripDetails data={data} />;
    case CANCELLED_KEY:
      return <TripRefundDetails data={data} width={100} />;
    case FAILED_KEY:
      return <TripRefundDetails data={data} width={100} />;
    default:
      return <TripDetails data={data} />;
  }
};

const TripInfoDetails = ({data}) => {
  const [showModal, setShowModal] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [modalData, setModalData] = useState('');
  const [qrCode, setQRCode] = useState('');
  const [userName, setUserName] = useState('');
  const [fileNames, setFileNames] = useState(null);
  const [acknowledgement, setAcknowledgement] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [customerMobileNumber, setCustomerNumber] = useState('');
  const [numberError, setNumberError] = useState('');
  const [agentText, setAgentText] = useState({});
  const [uriValue, setUriValue] = useState('');

  const authenticate = (uri?: string) => {
    resetModal();
    shareHotels(uri, cookie);
    setUriValue(uri);
    setShowLoader(true);
    setShowModal(true);
    whatsappLogin(callback);
  };

  const resetModal = () => {
    setModalData('');
    setFileNames('');
    setQRCode('');
    setUserName('');
    setAcknowledgement('');
  };

  const shareHotels = async (uri?: String, cookie?: string) => {
    const res = await shareHotelPropertiesPOSTPDF({
      div: 'div:first-child',
      url: `${apiConfig.__MYPARTNER_SERVER_CALL__}${uri}?view=1`,
      cookie: cookie,
    });

    setDataLoader(false);
    if (!res?.markdown || !res?.fileNames) {
      setErrorMsg('Something went wrong. Please try after sometime.');
    } else {
      setModalData(res?.markdown);
      setFileNames(res?.fileNames);
    }
  };

  const sendMessage = async () => {
    if (!customerMobileNumber || customerMobileNumber.length < 10) {
      setNumberError('Please enter a valid number');
      return;
    }
    setNumberError('');
    const postData = {
      images: [],
      contactId: `91${customerMobileNumber}`,
      type: 1,
    };
    Object.keys(fileNames).map(key => {
      const item = fileNames[key];
      postData.images.push({
        imageId: `${apiConfig.__MYPARTNER_SERVER_CALL__}${uriValue}`,
        message: agentText[key] || '',
        contentType: 1,
        contentPage: 1,
      });
    });

    const resp = await sendWhatsAppMessage(postData);
    if (resp && resp.data) {
      setAcknowledgement(resp.data.message || '');
      setModalData('');
    }
  };

  const sendWhatsAppMessage = async data => {
    const url = `${apiConfig.__MYPARTNER__}/api/v12/whatsapp/send`;

    return await megatron({
      name: 'Send WhatsApp Message',
      type: 'POST',
      url,
      requestData: JSON.stringify(data),
      credentials: 'include',
    });
  };

  const callback = resp => {
    if (resp.success && resp.data) {
      if (resp.data.qrUrl) {
        setQRCode(resp.data.qrUrl);
      }
      if (resp.data.userName) {
        setUserName(resp.data.userName);
      }
    } else if (!resp.success && resp.errors && resp.errors.relogin) {
      whatsappLogin(callback);
    } else {
      let errorMsg = 'Something went wrong. Please try after sometime.';
      if (resp.errors && resp.errors.message) {
        errorMsg = resp.errors.message;
      }
      setErrorMsg(errorMsg);
      resetModal();
    }
  };

  const whatsappLogin = async callback => {
    const url = `${apiConfig.__MYPARTNER__}/api/v12/whatsapp/login`;
    let last_index = 0;
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.withCredentials = true;
      xhr.setRequestHeader('Content-Type', 'multipart/form-data');

      xhr.onerror = function() {
        reject({success: false});
      };
      xhr.onprogress = function() {
        const curr_index = xhr.responseText.length;
        if (last_index == curr_index) return;
        const s = xhr.responseText.substring(last_index, curr_index);
        last_index = curr_index;
        const respJSON = JSON.parse(s);
        callback({...respJSON});
        if (respJSON.data && respJSON.data.responseComplete) {
          resolve(respJSON);
        } else {
          reject({success: false});
        }
      };
      xhr.send();
    });
  };
  const closeModal = () => {
    setShowModal(false);
    setErrorMsg('');
    resetModal();
  };

  useEffect(() => {
    if (errorMsg) {
      setShowLoader(false);
    } else if (qrCode || (userName && fileNames && modalData)) {
      setShowLoader(false);
    }
  }, [qrCode, userName, fileNames, modalData, errorMsg]);

  let cookie = getCookie('sessionid');

  const {vertical, trip_actions} = data;

  switch (vertical.toLowerCase()) {
    case 'hotels':
      return (
        <S.TripInfoDetailOuterWrap>
          <HotelDetails data={data} />
          {(trip_actions && trip_actions.length && (
            <TripActions authenticate={authenticate} tripActions={trip_actions} />
          )) ||
            null}

          <Modal isOpen={showModal} closeModal={closeModal} modalStyles={{width: '62vw'}}>
            <Styles.ModalHeader>Share Booking Voucher</Styles.ModalHeader>
            <Styles.ModalContainer>
              <Styles.ModalContent>
                {(showLoader && !dataLoader && (
                  <Styles.ModalContentLoader>
                    <IconSelector iconKey="linearloader" />
                  </Styles.ModalContentLoader>
                )) ||
                  null}
                {(!showLoader && dataLoader && (
                  <Styles.ModalContentLoader>
                    <IconSelector iconKey="linearloader" />
                  </Styles.ModalContentLoader>
                )) ||
                  null}
                {(acknowledgement && (
                  <>
                    <Styles.AcknowledgeContainer>
                      <Styles.AcknowledgeText>{acknowledgement}</Styles.AcknowledgeText>
                      <Styles.ModalButton onClick={closeModal}>Ok</Styles.ModalButton>
                    </Styles.AcknowledgeContainer>
                  </>
                )) ||
                  null}
                {(errorMsg && userName && (
                  <>
                    <Styles.ErrorText>{errorMsg}</Styles.ErrorText>
                  </>
                )) ||
                  null}
                {qrCode !== '' && userName === '' ? (
                  <WhatsAppLogin qrCode={qrCode} relogin={() => whatsappLogin(callback)} />
                ) : null}
                {(modalData && userName && <ShareHotelPreview modalData={modalData} />) || null}
              </Styles.ModalContent>
            </Styles.ModalContainer>
            <Styles.ModalFooter>
              {(userName && (
                <>
                  <Styles.UserInput>
                    <img
                      src="https://assets-gos3.goibibo.com/whats_logo-1597597257.png"
                      width="39px"
                      height="39px"
                    />
                  </Styles.UserInput>
                  <Styles.UserInput>
                    <Styles.InputBox
                      type="text"
                      placeholder="Customer mobile number"
                      maxLength={10}
                      autoFocus
                      value={customerMobileNumber}
                      onChange={e => {
                        const val = e.target.value;
                        const re = /^[0-9]+$/;
                        if (val === '' || re.test(val)) {
                          setCustomerNumber(val);
                        }
                      }}
                    />
                    {numberError ? (
                      <Styles.ErrorText margin="0 2rem" fs="1.2rem">
                        {numberError}
                      </Styles.ErrorText>
                    ) : (
                      <Styles.UserInfo>
                        Sent from: <span>{userName}</span>
                      </Styles.UserInfo>
                    )}
                  </Styles.UserInput>
                  <Styles.ModalButton disabled={!modalData} onClick={sendMessage}>
                    Share
                  </Styles.ModalButton>
                </>
              )) ||
                null}
            </Styles.ModalFooter>
          </Modal>
        </S.TripInfoDetailOuterWrap>
      );

    default:
      return null;
  }
};

export default TripInfoDetails;
